import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/dashboard',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../page/Dashboard.vue'),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/table',
                    component: () => import(/* webpackChunkName: "table" */ '../page/BaseTable.vue'),
                    meta: { title: '基础表格' }
                },
                {
                    path: '/add-Merchant',
                    component: () => import(/* webpackChunkName: "table" */ '../page/merchants/add-Merchant.vue'),
                    meta: { title: '添加商户' }
                },
                {
                    path: '/merchants-Manage',
                    component: () => import(/* webpackChunkName: "table" */ '../page/merchants/merchants-Manage.vue'),
                    meta: { title: '商户管理' }
                },
                {
                    path: '/order',
                    component: () => import(/* webpackChunkName: "table" */ '../page/order/order.vue'),
                    meta: { title: '商户管理' }
                },
                {
                    path:'/voice',
                    component:()=>import('@/page/voice/voice.vue'),
                    meta:{ title:'语音播报' }
                },
                {
                    path:'/main-service-provider',
                    component:()=> import('../page/mainserviceprovider/main-service-provider.vue'),
                    meta:{title:'主服务商'}
                },
                {
                    path:'/sub-service-provider',
                    component:()=> import('../page/subserviceprovider/sub-service-provider.vue'),
                    meta:{title:'子服务商'}
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../page/403.vue'),
                    meta: { title: '403' }
                },
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});
